/** @prettier */
import React from 'react';
import styled from 'styled-components';

export const StyledTable = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 96%;
  margin: ${({ type }) => (type === 'top' ? '38px 2% 4px 2%' : '-4% 2% 4px 2%')};
  border: 0;
`;

const StyledTableTopCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  width: 25%;

  div {
    padding: 0 10% 0 0;
  }

  .anticon {
    &:hover {
      color: #0079c0;
    }
  }
`;

export const TableTop = ({ children }) => (
  <StyledTable className="table_top" type="top">
    {children}
  </StyledTable>
);
export const TableBottom = ({ children }) => (
  <StyledTable className="table_bottom" type="bottom">
    {children}
  </StyledTable>
);

export const TableTopCounter = ({ children }) => (
  <StyledTableTopCount className="small-caps-light">{children}</StyledTableTopCount>
);

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  border: 0;
  padding: 0 6px 0 6px;
  margin-top: ${(props) => props.margin_top || '0px'};
`;
